<script setup lang="ts">
import { AppBackground, ProjectHeaderImage } from '@haskoning/vue-component-library'
import { docUrl } from '@/components/scenario-form/constants/constants'

function navigateToDoc() {
  const url = docUrl ? docUrl : '/docs/'
  window.open(url, '_blank')
}

window.navigateToDoc = navigateToDoc

const cards = [
  {
    name: 'Mila van Druten',
    image: '/Mila-extended.jpg',
    description:
      "Hi! As a climate risk consultant specializing in social vulnerability, I'm committed to putting vulnerable communities at the forefront of climate change studies. During climate hazards, losing access to essential resources like food and water can be life-threatening, even if you're not directly in harm's way. That’s why we created our spatial inequality tool. It helps identify critical routes and facilities which helps our clients understand how assist these communities to become more resilient."
  },
  {
    name: 'Elżbieta Zdebel',
    image: '/Elżbieta-extended.jpg',
    description:
      'As an urban planner, I’ve always had a feeling that vulnerability maps do not grasp movement and dynamics that characterize every space, but instead they show static situations. However, cities (or villages) are living organisms that have different cycles; they accommodate changing socio-economic functions and diverse flows. Spaces are anything but static, and that thought motivated me to find better ways to analyze how people live and move around to sustain their livelihoods and link those insights to potential climate risks that otherwise would have been overlooked."'
  },
  {
    name: 'Aleksander Uszczyk',
    image: '/Aleksander-extended.jpg',
    description:
      'As a seasoned GIS specialist with a robust programming background, I am driven by a passion for unraveling the complexities of spatial data in our ever-evolving environment. My expertise extends to understanding how observers interact with dynamically changing public spaces, leveraging spatial data to analyze and predict patterns of movement, behavior, and engagement. This allows for the creation of more responsive and adaptive urban / rural environments that provide to the needs of their inhabitants.'
  }
]
</script>
<template>
  <div class="fill-height test">
    <ProjectHeaderImage :lazy-src="'/header_lazy.jpg'" :src="'/header.jpeg'" />
    <AppBackground>
      <v-card-title class="title-text">Contact us & about the team</v-card-title>
      <v-spacer></v-spacer>
      <v-card-text class="body-text">
        <p style="margin-bottom: 16px">
          <span class="body-text">For help with using SPIN, please reach out to us via </span>
          <span class="text-primary">mila.van.druten@haskoning.com</span>
        </p>
        <p style="margin-bottom: 16px">
          <span class="body-text">Please also review our </span>
          <span
            class="text-primary"
            @click="navigateToDoc"
            style="cursor: pointer; display: inline-flex; align-items: center"
          >
            Documentation section
            <span class="mdi mdi-open-in-new" style="margin-left: 3px"></span>
          </span>
          <span class="body-text"> for assistance</span>.
        </p>
      </v-card-text>

      <v-container fluid>
        <v-row justify="space-between" align="stretch">
          <v-col
            v-for="(card, index) in cards"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="team-col"
          >
            <v-card>
              <v-img
                position="top"
                class="align-end top-aligned-img"
                :src="card.image"
                height="200"
                gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.2)"
                cover
              >
                <v-card-title class="text-white" v-text="card.name"></v-card-title>
              </v-img>

              <v-card-text class="body-text">{{ card.description }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </AppBackground>
  </div>
</template>

<style scoped>
.title-text,
.body-text,
.team-name {
  font-family: 'Roboto', Arial, Helvetica, sans-serif;
}

.title-text {
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 10px;
}

.body-text,
.team-card,
.team-card .v-card-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.team-name {
  text-align: center;
  width: 100%;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.mt-5 {
  margin-top: 40px;
}

.team-col {
  display: flex;
  justify-content: center;
  padding: 10px;
}

.team-card {
  width: 350px;
  min-width: 350px;
  max-width: 350px;
  margin: 0 auto;
  box-sizing: border-box;
  border-radius: 10px;
}

.team-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 220px;
  margin: 0 auto 16px auto;
  background: #f8f8f8;
  border-radius: 8px;
  overflow: hidden;
}

.team-image {
  width: 220px !important;
  height: 220px !important;
  border-radius: 8px;
  display: block;
}
.top-aligned-img >>> .v-img__img {
  background-position: top !important;
}

@media (max-width: 960px) {
  .team-col {
    margin-bottom: 16px;
  }
}
</style>
